// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"xJ-z","carouselContainer":"yJ-z"};